import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[age]',
  standalone: false
})
export class AgeValidatorDirective {
  constructor(private readonly vcr: ViewContainerRef) {}
}
